import { HomeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useLoading } from '@client/store/loading.store';
import { ERoutePaths } from '@client/types';

import type { ButtonColorType, ButtonVariantType } from 'antd/es/button';
import type { SizeType } from 'antd/es/config-provider/SizeContext';

type TCloseButton = {
  className?: string;
  disabled?: boolean;
  label?: string;
  icon?: React.ReactNode;
  route: ERoutePaths;
  size?: SizeType;
  variant?: ButtonVariantType;
  color?: ButtonColorType;
};

export const BackButton: React.FC<TCloseButton> = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loading } = useLoading();

  const {
    className,
    disabled = false,
    label = t('actions.back'),
    icon = <HomeOutlined />,
    route = ERoutePaths.HOME,
    variant = 'outlined',
    size = 'small',
    color = 'default',
  } = props;

  return (
    <Button
      key={'back'}
      size={size}
      variant={variant}
      className={className}
      disabled={disabled}
      icon={icon}
      color={color}
      loading={loading}
      onClick={() => navigate(route)}
    >
      {label}
    </Button>
  );
};
